import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isEqual } from 'lodash';

import { updateOffer } from '../../../common/api/clients/order.api';
import { queries } from '../../../common/api/queryKeys/queries';

export function useOfferEdit() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateOffer,
        onSuccess: (data) => {
            const offerId = data.id;
            return queryClient.refetchQueries({
                predicate: (query) => {
                    return (
                        isEqual(query.queryKey, queries.offers.detail(offerId)._ctx.approvalSettings.queryKey) ||
                        isEqual(query.queryKey, queries.offers.detail(offerId).queryKey)
                    );
                },
            });
        },
    });
}
